import { PropertyWithParts, propertyWithPartsSchema } from "@boark/shared/types/property-with-parts";
import { PropertyCreate } from "@boark/shared/types/property-create";
import { PropertyUpdate } from "@boark/shared/types/property-update";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
  request,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getProperties(): Promise<PropertyWithParts[]> {
  return request(`${API_BASE_URL}/property`, {
    schema: z.array(propertyWithPartsSchema),
    headers: { "Content-Type": "application/json" },
  });
}

export async function getProperty(id: string): Promise<PropertyWithParts> {
  return getRequest(`${API_BASE_URL}/property/${id}`, propertyWithPartsSchema);
}

export async function createProperty(
  property: PropertyCreate,
): Promise<PropertyWithParts> {
  return postRequest(`${API_BASE_URL}/property`, property, propertyWithPartsSchema);
}

export async function updateProperty(
  id: string,
  property: PropertyUpdate,
): Promise<PropertyWithParts> {
  return putRequest(`${API_BASE_URL}/property/${id}`, property, propertyWithPartsSchema);
}

export async function deleteProperty(id: string): Promise<void> {
  return deleteRequest(`${API_BASE_URL}/property/${id}`);
}
